import { DesktopAppAccess, MobileAppAccess } from './AppAccess';
import BrandWordmark from './BrandWordmark';
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';

const NAV = [
  { to: '/', label: 'Ana Sayfa' },
  { to: '/ozellikler', label: 'Özellikler' },
  { to: '/hakkimizda', label: 'Hakkımızda' },
  { to: '/fiyatlar', label: 'Fiyatlar' },
  { to: '/blog', label: 'Blog' },
  { to: '/iletisim', label: 'İletişim' },
];

const Logo = ({ className = 'h-9 w-9' }) => (
  <img src="/favicon.svg" alt="Tilki Otomasyon" width="36" height="36" className={className} />
);

const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // Rota değişince menüyü kapat
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  // Menü açıkken arka planı kilitle
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header className="sticky top-0 z-50 border-b border-hairline bg-surface">
      <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center justify-between gap-4 px-4">
        <Link to="/" className="flex flex-shrink-0 items-center gap-2.5 text-ink">
          <Logo />
          <BrandWordmark />
        </Link>

        {}
        <nav className="hidden items-center gap-5 xl:flex">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`relative whitespace-nowrap font-inter text-[15px] font-medium transition-colors hover:text-ink ${
                pathname === item.to ? 'text-ink' : 'text-ink-muted'
              }`}
            >
              {item.label}
              {pathname === item.to && (
                <span
                  className="absolute -bottom-2 left-1/2 h-0.5 w-5 -translate-x-1/2 rounded-full bg-brand-600"
                  aria-hidden="true"
                />
              )}
            </Link>
          ))}
          <DesktopAppAccess />
        </nav>

        <Link
          to="/demo"
          className="hidden flex-shrink-0 items-center gap-2 rounded-lg bg-primary px-5 py-2.5 font-inter text-sm font-semibold text-primary-foreground transition-colors hover:bg-brand-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-600 xl:inline-flex"
        >
          Demo Al
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>

        {}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? 'Menüyü kapat' : 'Menüyü aç'}
          aria-expanded={open}
          aria-controls="mobile-nav"
          className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-lg border border-hairline text-ink transition-colors hover:bg-surface-2 xl:hidden"
        >
          {open ? <X size={20} aria-hidden="true" /> : <Menu size={20} aria-hidden="true" />}
        </button>
      </div>

      {}
      {open && (
        <div
          id="mobile-nav"
          className="max-h-[calc(100dvh-4rem)] overflow-y-auto border-t border-hairline bg-surface xl:hidden"
        >
          <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-1 px-4 pb-5 pt-3">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`flex min-h-[44px] items-center rounded-lg px-3 py-3 font-inter text-base font-medium ${
                  pathname === item.to ? 'bg-brand-50 text-brand-700' : 'text-ink-muted'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <MobileAppAccess />
            <Link
              to="/demo"
              className="mt-2 flex min-h-[48px] items-center justify-center gap-2 rounded-lg bg-primary px-5 py-3 font-inter text-[15px] font-semibold text-primary-foreground"
            >
              Demo Al
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
